import '../App.css';

import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { RoutesV1 } from '../../../Common/Constants';
import { UIClaimsUnAuthRenderer } from '../../../Components/Authorization';
import CreateTicketFlowContainerUnauth from '../../../Components/V1/CreateTicketFlowContainerUnauth';
import { ServiceHealthUnauthWrapper } from '../../../Components/V1/ServiceHealthUnauthWrapper';
import { AppSessionContext } from '../../../Services/Services.Primary/SessionContext/AppSessionContext';
import FlightingInteractionService from '../../../Services/Services.Secondary/FlightingInteractionService';

const appSessionContext = AppSessionContext.getInstance();
const CreateTicketFlowElement = UIClaimsUnAuthRenderer(CreateTicketFlowContainerUnauth);
const ServiceHealthElement = UIClaimsUnAuthRenderer(ServiceHealthUnauthWrapper);

export const PublicApp = () => {
  FlightingInteractionService.getInstance().processQueryStringFlights();

  return (
    <BrowserRouter>
      <Routes>
        <Route path={`/:locale/${appSessionContext.VirtualDirectoryRoot}`}>
          <Route index element={<CreateTicketFlowElement />} />
          <Route path={RoutesV1.SupportV2} element={<CreateTicketFlowElement />} />
          <Route path={RoutesV1.PublicServiceHealth} element={<ServiceHealthElement />} />
          <Route path={RoutesV1.OldPublicServiceHealth} element={<ServiceHealthElement />} />
        </Route>
        <Route
          path="*"
          element={<Navigate to={`/${appSessionContext.Locale}/${appSessionContext.VirtualDirectoryRoot}`} replace />}
        />
      </Routes>
    </BrowserRouter>
  );
};
